import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// import { i18n } from '@alife/bc-shop-base';
import gdata from '@alife/bc-gdata';
// import eventManager from '@alife/scc-event-manager/event-manager';
import FastFeedbackInquiry from '@alife/scc-gangesweb-inquiry/fast-feedback';
import collinaInit from './collina-init';
// import IsInView from '@alife/bc-scroll-fix/is-in-view.js';

// const I18n = i18n.createI18n('fast_feedback');

class FastFeedback extends PureComponent {
  static propTypes = {
    fastFeedBackView: PropTypes.object,
    collinaJsServer: PropTypes.string,
    collinaCdnServer: PropTypes.string,
    location: PropTypes.string,
  };

  constructor(props = {}) {
    super(props);

    this._isFeedbackRendered = false;
    this.elWrapper = React.createRef();
    // this.onInViewChange = this.onInViewChange.bind(this);
  }

  componentDidMount() {
    this.renderFeedback();

    const {
      fastFeedBackView,
      collinaJsServer,
      collinaCdnServer,
      location,
    } = this.props;
    collinaInit({
      location,
      umidToken: fastFeedBackView.umidToken,
      collinaCdnServer,
      collinaJsServer,
    });
  }

  // onInViewChange(isInView) {
  //   if (isInView.bottom && !this._isFeedbackRendered) {
  //     this.renderFeedback();
  //   }
  //   eventManager.trigger('feedbackInViewChange', isInView);
  // }

  renderFeedback() {
    if (!this.elWrapper) {
      return;
    }
    const { fastFeedBackView } = this.props;
    const {
      crossdomainToken,
      uniqueToken,
      feedBackObjectId,
    } = fastFeedBackView;
    const params = {
      ...fastFeedBackView,
      container: this.elWrapper.current,
      language: gdata.get('languageType') || 'en',
      sourceID: feedBackObjectId,
      _host_token_: crossdomainToken,
      _csrf_token_: uniqueToken,
    };
    const isTopDomain = !/\.alibaba\.com$/.test(location.hostname);
    if (isTopDomain) {
      // eslint-disable-next-line
      params._csrf_token_ = '';
    }
    new FastFeedbackInquiry(params);
    this._isFeedbackRendered = true;
  }

  render() {
    const { i18n } = this.props;
    return (
      <div
        className="detail-module module-fastFeedback ls-feedback"
        id="J-ls-feedback"
      >
        {/* <IsInView
          topSpace={50}
          bottomSpace={50}
          checkType="both"
          onChange={this.onInViewChange}
        /> */}
        <h3 className="feedback-title">
          {i18n['fast_feedback.text_fast_feedback_send_message']}
        </h3>
        <div
          className="feedback-wrapper"
          id="fastFeedbackContent"
          ref={this.elWrapper}
        />
      </div>
    );
  }
}

export default FastFeedback;
